import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  y?: number;
}
export function Reveal({
  children,
  className = '',
  delay = 0,
  y = 24
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.16, 1, 0.3, 1]
  }} className={className} data-id="element-152" data-mp="3bjpc5vcw4fiv">
      {children}
    </motion.div>;
}